<div class="{{outerdivClass()}} outer-dropdown-class">
  <div class="breadcrumb-dropdown max-w-300" [style.width.px]="width()">
    <select #selectList [ngModel]="selectedValue()" (change)='sendSelected($event)' [style.width.px]="width()"
      class="pointer text-smd selectClass">
      @if (!groupProperty() || groupProperty() === '') {
        @for (data of dataForBreadcrumbs(); track data) {
          <!-- $any(data): dynamic string-key access on generic dropdown items — concrete types have no index signature -->
          <option [ngClass]="$any(data)[optionClassProperty()!] ? optionClass() : ''"
            [attr.value]="$any(data)['disabled'] ? null : $any(data)[valueProperty()!]"
            [disabled]="$any(data)['disabled']">
            {{$any(data)[nameProperty()!]}}
          </option>
        }
      } @else {
        @for (data of dataForBreadcrumbs(); track data) {
          <optgroup [attr.label]="$any(data)[nameProperty()!]">
            @if (showOneOptGroup()) {
              @for (type of $any(data)[groupProperty()!]; track type) {
                <option [value]="$any(type)[valueProperty()!]">
                  {{$any(type)[nameProperty()!]}}
                </option>
                @if (showCommingledExperience) {
                  @for (subType of $any(type)[groupProperty()!]; track subType) {
                    <option [value]="$any(subType)[valueProperty()!]">
                      &nbsp;&nbsp;- {{$any(subType)[nameProperty()!]}}
                    </option>
                  }
                }
              }
            } @else {
              @for (group of $any(data)[groupProperty()!]; track group) {
                @if (($any(group)[groupProperty()!]?.length ?? 0) > 0) {
                  @if ($any(group)[groupProperty()!].length === 1) {
                    <option [value]="$any(group)[groupProperty()!][0][valueProperty()!]">
                      {{$any(group)[nameProperty()!]}}
                    </option>
                  } @else {
                    <option [disabled]="true">
                      {{$any(group)[nameProperty()!]}}
                    </option>
                    @for (type of $any(group)[groupProperty()!]; track type) {
                      <option [value]="$any(type)[valueProperty()!]">
                        &nbsp;&nbsp;{{$any(type)[nameProperty()!]}}
                      </option>
                    }
                  }
                } @else {
                  <option [value]="$any(group)[valueProperty()!]">
                    {{$any(group)[nameProperty()!]}}
                  </option>
                }
              }
            }
          </optgroup>
        }
      }
    </select>
  </div>

  <div class="flex flex-wrap mx-[-15px] h-0 lg:min-h-3">
    <div class="col-span-12">
      <div class="flex">
        <div #hiddenSelected class="hiddenBreadcrumb text-smd"></div>
      </div>
    </div>
  </div>
</div>
